import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RecommendationsComponent } from './pages/recommendations/recommendations.component';
import { RecommendationComponent } from '../result/pages/recommendation/recommendation.component';

const routes: Routes = [
  { path: '', component: RecommendationsComponent, pathMatch: 'full' },
  { path: ':categoryUuid/detail', component: RecommendationComponent, pathMatch: 'full' },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecommendationsRoutingModule {}
